var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2511 2.97677C20.3117 2.11819 22.3789 4.18541 21.5203 6.24601L15.5968 20.4624C14.4384 23.2427 10.3636 22.7728 9.86839 19.8018L9.12938 15.3677L4.6953 14.6287C1.72431 14.1335 1.25437 10.0587 4.03465 8.90029L18.2511 2.97677ZM19.6742 5.47677C19.8459 5.06466 19.4324 4.65121 19.0203 4.82293L4.80388 10.7464C3.87712 11.1326 4.03377 12.4909 5.02409 12.6559L9.45818 13.3949C10.3011 13.5354 10.9617 14.196 11.1022 15.0389L11.8412 19.473C12.0062 20.4633 13.3645 20.62 13.7506 19.6932L19.6742 5.47677Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.06406a075cd8f2503f295332ed2d03cf.svg";
export { ForwardRef as ReactComponent };